import { Component, input } from '@angular/core';
import {
  NgDiagramNodeSelectedDirective,
  NgDiagramBaseNodeTemplateComponent,
  NgDiagramPortComponent,
  type NgDiagramNodeTemplate,
  type Node,
} from 'ng-diagram';


@Component({
  standalone: true,
  imports: [NgDiagramPortComponent, NgDiagramBaseNodeTemplateComponent],
  hostDirectives: [
    { directive: NgDiagramNodeSelectedDirective, inputs: ['node'] },
  ],
  templateUrl: './eNode.html',
  styleUrls: ['./eNode.scss'],
})
export class ENodeComponent implements NgDiagramNodeTemplate {
  node = input.required<Node>();

}